import { create } from 'zustand';
import { authApi } from '../services/api';

interface User { id: number; username: string; email: string; role: string; two_factor_enabled: boolean; }
interface AuthState {
  user: User | null; isAuthenticated: boolean; requires2fa: boolean;
  tempUsername: string; tempPassword: string;
  login: (u: string, p: string, otp?: string) => Promise<void>;
  logout: () => Promise<void>;
  fetchMe: () => Promise<void>;
}

export const useAuthStore = create<AuthState>(set => ({
  user: null,
  isAuthenticated: false,
  requires2fa: false, tempUsername: '', tempPassword: '',
  login: async (username, password, otp) => {
    const { data } = await authApi.login({ username, password, otp_token: otp });
    if (data.requires_2fa) { set({ requires2fa: true, tempUsername: username, tempPassword: password }); return; }
    set({ user: data.user, isAuthenticated: true, requires2fa: false });
  },
  logout: async () => {
    try { await authApi.logout(); } catch {}
    set({ user: null, isAuthenticated: false });
  },
  fetchMe: async () => {
    try {
      const { data } = await authApi.me();
      set({ user: data, isAuthenticated: true });
    } catch {
      set({ isAuthenticated: false });
    }
  },
}));
